import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css'; // External CSS

const TourSection = () => {
const navigate = useNavigate();

    const handleClick = () => {
        navigate('/china'); // e.g., '/contact' or '/booking'
      };
  return (
    <div className="tour-section">
      {/* First Row: Centered Heading */}
      <div className="heading-row">
        <h2><strong>Discover China</strong> <br/>Our Exclusive Global Destinations Tour!</h2>

      </div>

      {/* Second Row: Two Column Layout */}
      <div className="content-row">
        {/* Left Column: Images */}
        <div className="left-images">
          <img src="./images/china.jpg" className="tour-image2" />
          <img src="./images/china1.jpg" className="tour-image2" />
          <img src="/images/china3.jpg" className="tour-image2" />
          <img src="/images/china2.jpg" className="tour-image2" />
        </div>

        {/* Right Column: Description and Button */}
        <div className="right-content">
          <p>
            Embark on an unforgettable journey through China's rich history, stunning landscapes, and iconic landmarks.
             From the majestic Great Wall and the Forbidden City to the breathtaking views of
             Zhangjiajie and the serene beauty of the Li River, each destination offers a unique glimpse into
              the heart of this ancient land. <br/>

            We provide not only a well-curated travel experience but
             also warm hospitality and friendly service throughout your journey. Let us take care
              of the details,so you can enjoy every moment.
          </p>
          <button className="tour-button2" onClick={handleClick}>Explore the Wonders of China</button>
        </div>
      </div>
    </div>
  );
};

export default TourSection;
